export default {
  openTestCaseExecutionDialog(testCaseId: string, testCaseName: string): void {
    window.AP.dialog.create({
      key: 'test-case-execution-dialog',
      size: 'maximum',
      chrome: false,
      customData: {
        testCaseId,
        testCaseName,
      },
    });
  },
};
